module.exports = __webpack_public_path__ + "static/media/YM61_0.6506c658.jpg";